const $ = window.jQuery;
const $window = window.$window || $(window);

const main = {

    /*duration: 800,
    offset: -100,*/

    init() {
        //alert('HELLO');

    }
}


export default main;